module.exports =
{
  parallel      : require('./parallel.js'),
  serial        : require('./serial.js'),
  serialOrdered : require('./serialOrdered.js')
};



//////////////////
// WEBPACK FOOTER
// ./~/asynckit/index.js
// module id = 1173
// module chunks = 0 1 3